import React, { useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      setIsOpen(false);
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed-top">
      {/* Top utility navigation */}
      <div className="bg-light py-1">
        <div className="container">
          <ul className="list-unstyled d-flex justify-content-end gap-4 m-0">
            <li>
              <a 
                onClick={() => scrollToSection('about')} 
                className="text-muted text-decoration-none small d-inline-flex align-items-center utility-nav-link" 
                href="#about"
                style={{ fontSize: '0.9rem' }}
              >
                <i className="bi bi-info-circle me-2" style={{ fontSize: '1.1rem' }}></i>
                ABOUT MIRA PEARLS
              </a>
            </li>
            <li>
              <a 
                onClick={() => scrollToSection('contact')} 
                className="text-muted text-decoration-none small d-inline-flex align-items-center utility-nav-link" 
                href="#contact"
                style={{ fontSize: '0.9rem' }}
              >
                <i className="bi bi-envelope me-2" style={{ fontSize: '1.1rem' }}></i>
                CONTACT US
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="navbar navbar-expand-lg bg-white">
        <div className="container">
          <a className="navbar-brand" href="#home">
            <img src="/images/logo.png" alt="Mira Pearls Logo" height="80" />
          </a>
          <button 
            className="navbar-toggler" 
            type="button" 
            onClick={toggleMenu}
            aria-controls="navbarNav" 
            aria-expanded={isOpen} 
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav gap-5 mx-auto">
              <li className="nav-item">
                <a 
                  onClick={() => scrollToSection('white-pearls')} 
                  className="nav-link fw-semibold" 
                  href="#white-pearls"
                >
                  WHITE SOUTH SEA PEARLS
                </a>
              </li>
              <li className="nav-item">
                <a 
                  onClick={() => scrollToSection('golden-pearls')} 
                  className="nav-link fw-semibold" 
                  href="#golden-pearls"
                >
                  GOLDEN SOUTH SEA PEARLS
                </a>
              </li>
              <li className="nav-item">
                <a 
                  onClick={() => scrollToSection('black-pearls')} 
                  className="nav-link fw-semibold" 
                  href="#black-pearls"
                >
                  TAHITIAN PEARLS
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar; 